// extracted by mini-css-extract-plugin
module.exports = {"lang":"LanguageSelector_lang__3Wgka","modal":"LanguageSelector_modal__2xJ6O","active":"LanguageSelector_active__37ode"};